import script from "./ProductDeals.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDeals.vue?vue&type=script&setup=true&lang=js"

import "./ProductDeals.vue?vue&type=style&index=0&id=a5b44a5c&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5b44a5c"]])

export default __exports__